<template>
  <Carousel
    :items="devices"
    :icon-spacing="110"
    :side-scale="0.5"
    :card-width="736"
    :initial-index="initialIndex"
    @change="handleCarouselChange"
  >
    <template #card="{ item, isActive }">
      <DeviceCard :item="item" :is-active="isActive" />
    </template>

    <template #icon="{ item, isActive }">
      <DeviceIcon :item="item" :is-active="isActive" />
    </template>

    <template #append-icon>
      <AddDeviceButton />
    </template>
  </Carousel>
</template>

<script lang="ts" setup>
  import Carousel from '@/components/carousel/index.vue'
  import DeviceCard from './DeviceCard.vue'
  import DeviceIcon from './DeviceIcon.vue'
  import AddDeviceButton from './AddDeviceButton.vue'
  import { type DeviceItem, useDeviceStore } from '@/stores/device'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  import { BaseDevice } from '@rapoo/device-sdk'

  const deviceStore = useDeviceStore()
  const { devices, currentDevice } = storeToRefs(deviceStore)

  /**
   * 生成设备稳定标识 key：vendorId_currentPid
   * 设备重连时 id 会变，但 pid/vid 不变，用此 key 确保 initialIndex 能稳定匹配。
   */
  function getDeviceKey(device: BaseDevice | null): string {
    if (!device) return ''
    return `${device.manifest.hardware.vendorId}_${device.manifest.hardware.currentPid}`
  }

  const initialIndex = computed(() => {
    const currentKey = getDeviceKey(currentDevice.value)
    if (!currentKey) return 0
    return devices.value.findIndex((item) => getDeviceKey(item.original) === currentKey)
  })

  const handleCarouselChange = (item: DeviceItem) => {
    void deviceStore.selectDevice(item.original)
  }
</script>

<style lang="scss" scoped></style>
